import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  TextField,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Button,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Swal from "sweetalert2";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
  details: {
    display: "flex",
    flexDirection: "column",
    gap: "14px",
    padding: "16px",
  },
  button: {
    height: "40px",
    alignSelf: "flex-start",
  },
}));

const DayPlan = ({ day, weeklyData, setWeeklyData, cfg = {} }) => {
  const classes = useStyles();
  const existing = weeklyData.find((d) => d.day === day);
  const [topic, setTopic] = useState(existing ? existing.top_sub_top : "");
  const [period, setPeriod] = useState(existing ? existing.no_of_period : "");
  const [notes, setNotes] = useState(existing ? existing.imp_note : "");
  const [activity, setActivity] = useState(existing ? existing.cls_activity : "");
  const [outcome, setOutcome] = useState(existing ? existing.learning_outcome || "" : "");
  const [work, setWork] = useState(existing ? existing.homework : "");
  const [value, setValue] = useState(
    existing ? (existing.if_no_reas_with_comp_date ? "no" : existing.accomplished || "") : ""
  );
  const [reason, setReason] = useState(existing ? existing.if_no_reas_with_comp_date : "");

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const handleSave = (e) => {
    e.preventDefault();
    const obj = {
      day,
      top_sub_top: topic,
      no_of_period: period,
      imp_note: notes,
      cls_activity: activity,
      homework: work,
      accomplished: value,
      if_no_reas_with_comp_date: reason,
      ...(cfg.learningOutcomes ? { learning_outcome: outcome } : {}),
    };
    setWeeklyData((prev) => [...prev.filter((d) => d.day !== day), obj]);
    Swal.fire({
      position: "center",
      icon: "success",
      title: "Your work has been saved",
      showConfirmButton: false,
      timer: 1500,
    });
  };

  return (
    <Accordion>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <Typography className={classes.heading}>
          {day}
          {existing ? (
            <span style={{ marginLeft: 10, color: "#2e7d32", fontSize: "0.85em" }}>
              ✓ Saved
            </span>
          ) : null}
        </Typography>
      </AccordionSummary>
      <AccordionDetails className={classes.details}>
        <TextField
          fullWidth
          id="topic"
          label="Topic/Sub-Topic"
          variant="outlined"
          value={topic}
          onChange={(e) => setTopic(e.target.value)}
        />
        <TextField
          fullWidth
          id="periods"
          label={cfg.periodNumberLabel ? "Period Number" : "No. of Periods"}
          variant="outlined"
          value={period}
          onChange={(e) => setPeriod(e.target.value)}
        />
        <TextField
          fullWidth
          id="notes"
          label={cfg.teacherActivityLabel ? "Teacher's Activity" : "Important Notes"}
          variant="outlined"
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
        />
        <TextField
          fullWidth
          id="activities"
          label="Class Activities"
          variant="outlined"
          value={activity}
          onChange={(e) => setActivity(e.target.value)}
        />
        {cfg.learningOutcomes && (
          <TextField
            fullWidth
            id="outcomes"
            label="Learning Outcomes"
            variant="outlined"
            value={outcome}
            onChange={(e) => setOutcome(e.target.value)}
          />
        )}
        <TextField
          fullWidth
          id="homework"
          label={cfg.assignmentLabel ? "Assignment" : "Home Work"}
          variant="outlined"
          value={work}
          onChange={(e) => setWork(e.target.value)}
        />
        {!cfg.hideAccomplished && (
          <>
            <FormControl component="fieldset">
              <FormLabel component="legend">Accomplished</FormLabel>
              <RadioGroup
                aria-label="accomplished"
                name="accomplished"
                value={value}
                onChange={handleChange}
              >
                <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="no" control={<Radio />} label="No" />
              </RadioGroup>
            </FormControl>
            {value === "no" ? (
              <TextField
                fullWidth
                id="reason"
                label="If No Reason With Completion"
                variant="outlined"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
              />
            ) : (
              ""
            )}
          </>
        )}
        <Button
          onClick={(e) => handleSave(e)}
          className={classes.button}
          variant="contained"
          color="primary"
        >
          Save
        </Button>
      </AccordionDetails>
    </Accordion>
  );
};

export default DayPlan;
